
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  LogoResource,
} from '../models';
import {
    LogoResourceFromJSON,
    LogoResourceToJSON,
} from '../models';

export interface UpdateCompanyLogoRequest {
    file: Blob;
}

/**
 * 
 */
export class ClientCompanyLogoApi extends runtime.BaseAPI {

    /**
          */
    async deleteCompanyLogoRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/client-settings/api/logo`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async deleteCompanyLogo(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCompanyLogoRaw(initOverrides);
    }

    /**
          */
    async getCompanyLogoRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<string>({
            path: `/client-settings/api/logo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async getCompanyLogo(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getCompanyLogoRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async updateCompanyLogoRaw(requestParameters: UpdateCompanyLogoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LogoResource>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling updateCompanyLogo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request<LogoResource>({
            path: `/client-settings/api/logo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=LogoResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async updateCompanyLogo(requestParameters: UpdateCompanyLogoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LogoResource> {
        const response = await this.updateCompanyLogoRaw(requestParameters, initOverrides);
        return response._data;
    }

}
